module.exports = __webpack_public_path__ + "static/media/play.85e84a6f.svg";